
const BASE = (
  process.env.REACT_APP_API_BASE_URL || ""
).replace(/\/$/, "");


// =========================================================
// BASE REQUEST HELPER
// =========================================================

async function request(path, options = {}) {
  const response = await fetch(
    `${BASE}/api/superadmin/${path}`,
    {
      credentials: "include",
      cache: "no-store",
      ...options,
    }
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(
      data.detail ||
      `Request failed (${response.status})`
    );

    error.status = response.status;

    throw error;
  }

  return data;
}


// =========================================================
// CSRF
// =========================================================

export const getSuperAdminCsrf = () =>
  request("csrf/");


// =========================================================
// AUTHENTICATED USER
// =========================================================

export const getSuperAdminUser = () =>
  request("me/");


// =========================================================
// DASHBOARD OVERVIEW
// =========================================================

export const getSuperAdminOverview = () =>
  request("overview/");


// =========================================================
// POST HELPER WITH CSRF
// =========================================================

async function post(path, body = {}) {
  const { csrfToken } = await getSuperAdminCsrf();

  return request(path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    body: JSON.stringify(body),
  });
}


// =========================================================
// SUPER ADMIN PASSWORD LOGIN
// =========================================================

export const superAdminLogin = (
  username,
  password
) =>
  post("login/", {
    username,
    password,
  });


// =========================================================
// START FIRST-TIME AUTHENTICATOR ENROLLMENT
// =========================================================

export const startSuperAdmin2FAEnrollment = () =>
  post("2fa/enroll/start/", {});


// =========================================================
// CONFIRM FIRST-TIME AUTHENTICATOR ENROLLMENT
// =========================================================

export const confirmSuperAdmin2FAEnrollment = (
  token
) =>
  post("2fa/enroll/confirm/", {
    token,
  });


// =========================================================
// VERIFY OTP OR RECOVERY CODE
// =========================================================

export const verifySuperAdmin2FA = (payload) =>
  post("2fa/verify/", payload);


// =========================================================
// LOGOUT
// =========================================================

export const superAdminLogout = () =>
  post("logout/", {});


// =========================================================
// PLATFORM RESTAURANT MANAGEMENT
// =========================================================

export const getPlatformRestaurants = (page = 1) =>
  request(`restaurants/?page=${page}`);

export const createPlatformRestaurant = (data) =>
  post("restaurants/", data);

export const updatePlatformRestaurant = async (
  id,
  data
) => {
  const { csrfToken } = await getSuperAdminCsrf();

  return request(`restaurants/${id}/`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    body: JSON.stringify(data),
  });
};

export const assignPlatformOwner = (
  id,
  username
) =>
  post(
    `restaurants/${id}/assign-owner/`,
    { username }
  );
